<app-table
  [actionColumnWidth]="400"
  [columns]="columns"
  [loading]="loading"
  [value]="alterskategorien"
  filename="CHOP.ALTERSKATEGORIEN"
  sortField="code">
  <ng-template
    (onClick)="showCreateDialog()"
    appToolbarButton
    icon="fal fa-plus"
    labelKey="CHOP.CREATE_ALTERSKATEGORIE"></ng-template>
  <ng-template
    (onClick)="openDetail($event.row)"
    appActionButton
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>
  <ng-template
    (onClick)="showEditDialog($event.row)"
    appActionButton
    icon="fal fa-pencil"
    labelKey="ACTIONS.EDIT"></ng-template>
  <ng-template
    (onClick)="delete($event.row)"
    appActionButton
    icon="fal fa-trash"
    labelKey="ACTIONS.DELETE"
    type="danger"></ng-template>
</app-table>
